import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { ItemOnboardingMenu } from '../../../../onboarding-menu';
import { ValuesLevelOne } from '..';
import l from '../../../../../../lang';

interface FormObserverProps {
  onChangeOnboardingMenu: (menu: ItemOnboardingMenu[]) => void;
}

export const FormObserver = ({ onChangeOnboardingMenu }: FormObserverProps) => {
  const { values } = useFormikContext<ValuesLevelOne>();
  useEffect(() => {
    const {
      company,
      name,
      lastName,
      fantasyName,
      country,
      documentType,
      document,
      website,
      phone,
      subIndustryId,
      functionalCurrency,
    } = values;

    const isCompanyCompeted = values.company !== null;
    const isCompanySelected = !isCompanyCompeted;
    const companyDataCompleted = !!fantasyName && !!subIndustryId && !!website;
    const companyDataSelecetd = isCompanyCompeted && !companyDataCompleted;
    const legalInfoCompleted =
      !!name && !!country && !!documentType && !!document && !!functionalCurrency && (!company ? !!lastName : true);
    const legalInfoSelected = companyDataCompleted && !legalInfoCompleted;
    const contactInfoCompleted = !!phone;
    const contactInfoSelected = legalInfoCompleted && !contactInfoCompleted;

    onChangeOnboardingMenu([
      { title: l('companyInformation.kycOneMenu.introduction'), completed: true, selected: false },
      { title: l('companyInformation.kycOneMenu.typeOfCompany'), completed: isCompanyCompeted, selected: isCompanySelected },
      {
        title: l('companyInformation.kycOneMenu.companyData'),
        subItems: [
          {
            title: l('companyInformation.basicInfo.commercialInformation'),
            completed: companyDataCompleted,
            selected: companyDataSelecetd,
          },
          {
            title: l('companyInformation.basicInfo.legalInformation'),
            completed: legalInfoCompleted,
            selected: legalInfoSelected,
          },
          {
            title: l('companyInformation.basicInfo.contactInformation'),
            completed: contactInfoCompleted,
            selected: contactInfoSelected,
          },
        ],
      },
    ]);
  }, [values]);
  return null;
};
